export default __webpack_public_path__ + "static/media/noun_root canal_1945562.745b48b1.png";